// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "flights-3h5ev";
export { _1 as "__esModule", _2 as "flights" }
export default { "__esModule": _1, "flights": _2 }
